<template functionnal>
  <img class="logo" :src="file" alt="logo" />
</template>

<style lang="scss">
.logo {
  display: inline-block;
  vertical-align: middle;
}
</style>

<script>
export default {
  name: "Logo",
  props: {
    file: {
      type: String,
      required: true,
    },
  },
};
</script>
